import { type MCPServerInfo } from '../../types';

const LaunchDarklyServer: MCPServerInfo = {
  serverId: 'LAUNCHDARKLY',
  name: 'LaunchDarkly (Legacy)',
  slug: 'launchdarkly',
  description:
    'LaunchDarkly MCP Server for managing feature flags and AI Configs',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/launchdarkly/mcp-server',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@launchdarkly/mcp-server'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['launchDarklyApiKey'],
    properties: {
      launchDarklyApiKey: {
        type: 'string',
        description: 'LaunchDarkly API access token',
        sensitive: true
      },
      launchDarklyServerUrl: {
        type: 'string',
        description:
          'Optional server URL for EU/Federal instances (e.g. https://app.eu.launchdarkly.com)',
        sensitive: false,
        default: ''
      },
      launchDarklyScope: {
        type: 'string',
        description: 'Optional scope restriction (e.g. read)',
        sensitive: false,
        default: ''
      }
    }
  },
  deprecated: true
};

export default LaunchDarklyServer;
